/* Cereja Real: obriga a escolha de Grão ou Moído antes de adicionar ao carrinho. v1.2 de 15/10/2026
   Vale para a página de produto e para a gaveta quick-add. Se a URL já traz ?variant=, respeita a variante escolhida.
   Carregado em layout/theme.liquid. A barra fixa do celular (cr-pdp-extras) lê data-cr-pending do botão real.
   Nota: form.id não pode ser usado (o input name="id" do Dawn sombreia a propriedade); usar getAttribute('id'). */
(function(){
  var MSG='Escolha Grão ou Moído';
  var HINT='Escolha uma opção para continuar.';
  var css='.cr-req__hint{font-family:Outfit,sans-serif;font-size:12.5px;color:#8A1538;margin:8px 0 0}'+
    '.cr-req--shake{animation:crReqShake .4s ease}'+
    '@keyframes crReqShake{0%,100%{transform:translateX(0)}25%{transform:translateX(-5px)}75%{transform:translateX(5px)}}';
  var st=document.createElement('style'); st.textContent=css; document.head.appendChild(st);
  function fid(form){ return form&&form.getAttribute?(form.getAttribute('id')||''):''; }
  function isProductForm(form){ var id=fid(form); return id.indexOf('product-form-')===0 && id.indexOf('product-form-installment')!==0; }
  function scopeOf(el){ return el.closest('.quick-add-modal__content-info, product-info, .product, section, [id^="shopify-section"]')||document; }
  function formFor(p){
    var sid=p.getAttribute('data-section');
    var f=sid?document.getElementById('product-form-'+sid):null;
    if(f && p.closest('quick-add-modal') && !f.closest('quick-add-modal')) f=null;
    if(f) return f;
    var forms=scopeOf(p).querySelectorAll('form[id^="product-form-"]');
    for(var i=0;i<forms.length;i++){ if(isProductForm(forms[i])) return forms[i]; }
    return null;
  }
  function pickerFor(form){
    var sid=fid(form).replace('product-form-','');
    var scope=scopeOf(form);
    return scope.querySelector('variant-radios[data-section="'+sid+'"], variant-selects[data-section="'+sid+'"]')||scope.querySelector('variant-radios, variant-selects');
  }
  function submitBtn(form){ return form.querySelector('button[type=submit]')||document.querySelector('button[type=submit][form="'+fid(form)+'"]'); }
  function label(btn){ var s=btn.querySelector('span:not(.sold-out-message)'); return s||btn; }
  function setPending(form,on){
    if(!form) return; var btn=submitBtn(form); if(!btn) return;
    var span=label(btn);
    if(on){ if(!btn.dataset.crLabel) btn.dataset.crLabel=span.textContent; btn.dataset.crPending='1'; span.textContent=MSG; }
    else if(btn.dataset.crPending){ delete btn.dataset.crPending; span.textContent=btn.dataset.crLabel||span.textContent; }
    var sb=document.querySelector('.cr-sticky__btn'); if(sb && !btn.closest('quick-add-modal')) sb.textContent=on?MSG:'Adicionar ao carrinho';
  }
  function setup(){
    document.querySelectorAll('variant-radios, variant-selects').forEach(function(p){
      if(p.dataset.crReq) return;
      var radios=p.querySelectorAll('input[type=radio]'); if(!radios.length){ p.dataset.crReq='no-radios'; return; }
      var inModal=!!p.closest('quick-add-modal');
      if(!inModal && /[?&]variant=/.test(location.search)){ p.dataset.crReq='url'; return; }
      p.dataset.crReq='1';
      radios.forEach(function(r){ r.checked=false; });
      p.classList.add('cr-req--pending');
      setPending(formFor(p),true);
      p.addEventListener('change',function(){
        p.classList.remove('cr-req--pending','cr-req--shake');
        var h=p.querySelector('.cr-req__hint'); if(h) h.remove();
        setPending(formFor(p),false);
      });
    });
  }
  document.addEventListener('submit',function(e){
    try{
      var form=e.target; if(!form||!isProductForm(form)) return;
      var btn=submitBtn(form); if(!btn||!btn.dataset.crPending) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var p=pickerFor(form); if(!p) return;
      p.classList.remove('cr-req--shake'); void p.offsetWidth; p.classList.add('cr-req--shake');
      if(!p.querySelector('.cr-req__hint')){ var h=document.createElement('p'); h.className='cr-req__hint'; h.textContent=HINT; p.appendChild(h); }
      p.scrollIntoView({block:'center',behavior:'smooth'});
    }catch(err){ if(window.console) console.warn('cr-variant-required', err); }
  },true);
  var t=null;
  function schedule(){ if(t) return; t=setTimeout(function(){ t=null; setup(); },80); }
  function start(){ setup(); new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true}); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
})();
